import $ from 'jquery';

export const navigation = {

	initToggle: () => {

		$(".navigation__toggle").on( 'click', () => {

			$("html").toggleClass("has-nav-toggled");

		} );

	},

};